export class RemoveGiftAction {
  static readonly type = '[Basket] Remove gifts';
  constructor(public invalidIdxKeys: string[]) {}
}
